import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateUpdateModerationVacancy = {
  updateModerationVacancy: { data: null, loading: false, error: null },
};

export const updateModerationVacancy = createAsyncThunk('user/updateModerationVacancy', async ({ id, ...data }, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .put(`${process.env.REACT_APP_SERVER_API}/vacancies/${id}/moderation`, data, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerUpdateModerationVacancy = {
  [updateModerationVacancy.pending]: (state) => {
    state.updateModerationVacancy.loading = true;
    state.updateModerationVacancy.error = null;
  },
  [updateModerationVacancy.fulfilled]: (state, action) => {
    state.updateModerationVacancy.loading = false;
    state.updateModerationVacancy.data = action.payload;
    state.updateModerationVacancy.error = null;
  },
  [updateModerationVacancy.rejected]: (state, action) => {
    state.updateModerationVacancy.loading = false;
    state.updateModerationVacancy.error = true;
  },
};
